module.exports = {
    options: {
        language: '言語',
        zh: '簡体中文',
        en: '英語',
        jp: '日本語',
        nodata: 'データなし',
        addSucccess: '追加成功',
        succcess: '操作成功',
        more: 'もっと見る',
        recommend: 'おすすめ',
        text1: 'このホテルの報價を採用しますか',
        text2: '確定',
        text3: 'キャンセル',
        text4: 'ヒント',
        text5: '採用成功',
        text6: '会議ニーズ公開成功',
        text7: 'この会議室はこの桌型をサポートしていません',
        text8: 'なし',
        ok: '確定',
        cancel: 'キャンセル',
        tip: 'リマインダー',
    },
    header: {
        home: 'ホーム',
        meetingVenue: '会議場',
        service: '付帯サービス',
        cyclopedia: 'CSRプロジェクトセンター',
        jion: 'ホテル入居',
        abputUs: '私たちについて',
        memberCenter: '会員ホーム',
        userInfo: 'アカウント情報',
        applicationCenter: 'マーチャントセンター',
        cooperative: '奢侈品ゾーン',
        supplier: 'サプライヤー入居',
    },
    order: {
        all: 'すべて',
        submitted: '提出済み',
        obtained: '方案取得済',
        communicate: '連絡待ち',
        reserved: '予約済み',
        completed: '完了',
        cancelled: 'キャンセル',

        confirmed: '確認待ち',
        verify: '確認済',
        selected: '選定待ち',
        communication: '連絡待ち',
        bargain: '契約待ち',
        settle: '清算待ち',
        closedAccount: '清算済',
        process: '入札停止'
    },
    bottom_nav: {
        text1: '会之星について',
        text2: '会社概要',
        text3: 'お問い合わせ',
        text4: '人材募集',
        text5: '提携合作',
        text6: 'ホテル会場入居',
        text7: '付帯サービス提供者入居',
        text8: 'ヘルプセンター',
        text9: 'パスワードを忘れた',
        text10: 'よくある質問',
        text11: 'ビジネス合作',
        text12: '侵害苦情ガイド',
        text13: 'WeChatカスタマーサービス',
        text14: '全国統一ホットライン',
        text15: 'オンライン相談',
        text16: '蘇州星添越数字技術有限公司',
        text17: '蘇州市喜慶路99号斜杠広場4010',
        text18: 'グローバル会議産業チェーンホテル直購プラットフォーム',
        text19: '蘇ICP備2025174180号-1'
    },
    bottom_page: {
        text1: 'カスタマイズサービスフロー',
        text2: '1分で会議ニーズを公開',
        text3: '会議基本ニーズを入力',
        text4: '10分で会議アドバイザーが電話',
        text5: '専属アドバイザー1対1フォロー',
        text6: '30分で会議方案を取得',
        text7: '方案筛选スマートマッチング',
        text8: '会議場見学予約',
        text9: '実景化高度一致',
        text10: '活動円満終了',
        text11: '全程サービス品質保証',
    },
    citySelect: {
        text1: '都市名を入力してください',
    },
    aboutUs: {
        text1: '会社概要',
        text2: '会之星は、企業にワンストップ会議サービスを提供することを目指しています。高度に統合されたリソース、専門的な管理、心のこもったサービスで、お客様を支援し、会議の品質を向上させ、会議価値を創造し、会議目標を実現します。',
        text3: 'もっと詳しく',
        text4: '発展历程',
        text5: '会之星の発展と成長は、大地と根系のように、長河の奔流の波の下には無声の蓄積があり、每一次の突破口の鋒芒には年輪に沈殿した光が隠されています。',
        text6: 'もっと詳しく',
        text7: '投資者関係',
        text8: 'リスクと機会の中で、産業趨勢の微光を敏感に捉え、周期波動の中で長期価値の座標を錨定する必要があります。每一次の決定は認知の実現であり、每一次の待機は時間との契約です。',
        text9: 'もっと詳しく',
        text10: '戦略的合作者',
        text11: '会之星のグローバルホテル直購リソースは3000以上、直結リソースは3万以上、グローバル知名ホテルと深度合作し、足跡は各核心地に広がっています。',
        text12: 'もっと詳しく',
        text13: '都市パートナー計画',
        text14: '急速な発展の商業浪潮の中で、「都市パートナー計画」への参加を心から招待し、手を携えて市場を開拓し、未来を共に勝ち取ります！都市パートナーとして、ブランドサポート、優質リソース、専門トレーニング、豊富な報酬メカニズムを獲得し、当地市場の戦略パートナーとなります。',
        text15: '私たちに参加し、パートナーの力で都市商機を点火しましょう！一つの都市、一人のパートナー、一緒に無限の可能性を成就しましょう！',
    },
    appCenter: {
        text1: '会之星グローバル会議産業チェーンホテル直購プラットフォーム',
        text2: '会議品質を向上',
        text3: '会議価値を創造',
        text4: '会議目標を実現',
        text5: 'ホテルサービスセンター',
        text17: 'Hotel Service Center',
        text6: 'ホテル 会議センター オリンピックスポーツセンター 特殊会場',
        text7: '顧客サービスセンター',
        text18: 'Customer Service Center',
        text8: 'ワンストップ会議サービス',
        text9: '付帯サービスセンター',
        text19: 'Matching service Center',
        text10: '会議企画 設備レンタル 広告物料 芸能機関 警備サービス',
        text11: '観光サービスセンター',
        text20: 'Tourism Service Center',
        text12: '観光相談 観光計画 ガイドサービス トレーニング拡張 トレーニング 研学',
        text13: 'チケットサービスセンター',
        text21: 'Ticketing Service Center',
        text14: '行程計画 チケット予約 退票変更 車両サービス バトラーサービス',
        text15: '結婚式サービスセンター',
        text22: 'Wedding Service Center',
        text16: '結婚式企画 結婚式実行 撮影カメラ スタイリングサービス 蜜月手配',
    },
    appCenter_service: {
        text1: '会議付帯サービス',
        text2: '効率的に会議ニーズを解決',
        text3: 'あなたの携帯電話番号',
        text4: '携帯認証コード',
        text5: '認証コードを取得',
        text6: '無料予約申請',
        text7: '厳選会議付帯サービス',
        text8: '素晴らしい活動事例',
        text9: '無料相談電話',
        text10: 'オンライン相談',
        more: 'もっと見る',

        text11: '観光サービスセンター',
        text12: 'Tourism Service Center',
        text13: '観光相談 観光計画 ガイドサービス',

        text14: 'チケットサービスセンター',
        text15: 'Ticketing Service Center',
        text16: '行程計画 チケット予約 退票変更',

        text17: '結婚式サービスセンター',
        text18: 'Wedding Service Center',
        text19: '結婚式企画 結婚式実行 蜜月計画',

        text20: '創意企画',
        text21: '全流程会議企画方案を提供',

        text22: '舞台美術設置',
        text23: '専門チーム、活動落地を保証',

        text24: '撮影カメラ',
        text25: 'ライブ編集、音声動画処理',

        text26: '同時通訳',
        text27: '正確、効率的な多言語情報伝達',

        text29: '広告制作',
        text30: '最適な物料、活動イメージを提供',

        text31: '芸能サービス',
        text32: '会議活動に活力と亮点を追加',

        text33: '車両サービス',
        text34: '安全、定時、快適なサービスを提供',

        text35: 'ギフトカスタマイズ',
        text36: '活動テーマとイメージを昇華',

        text37: 'アウディ新車展示会',
        text38: 'チリクリワイナリー試飲会',
        text39: '中国釣りマスター巡回賽',
        text40: '美奥歯科公益活動',

        text41: 'サプライヤー名',
        text42: '国',
        text43: '営業許可証',
        text44: 'ユーザー名',
        text45: 'パスワード',
        text49: 'パスワード確認',
        text46: '携帯番号',
        text47: '認証コード',
        text48: 'メール',
        text50: 'アップロード',
        text51: '画像をアップロードしてください',
        text52: '認証コードを送信',
        text53: '提出',
        text54: 'キャンセル',
        text55: 'パスワードを入力してください',
        text56: '二回の入力パスワードが一致することを確認してください',
        text57: 'サプライヤー入居',
        text58: '{value}を入力してください',
        text59: '正しい携帯電話番号を入力してください',
        text60: 'パスワードに中文を含めることはできません',
        text61: '送信成功',
        text62: '入居済、ログインへ',
    },
    conferenceSpace: {
        all: '制限なし',
        text1: 'ホテル、ランドマーク、商業圏キーワードを入力',
        text2: '検索',
        text3: 'ホテル',
        text4: '地理位置',
        text5: '会場タイプ',
        text6: 'ホテルブランド',
        text7: 'グループまたはホテル名を入力',
        text8: '収容人数',
        text9: '会場面積',
        text10: '標準部屋数',
        text11: 'スタイル特徴',
        text12: '会場価格',
        text13: 'ホテル設備',

        text14: '会場',
        text15: '会場层高',
        text16: '会場条件',
        text17: '所在階層',
        text18: '会場設備',
        text30: '住所',
        text31: '面積',
        text32: '层高',
        text33: '最大収容人数',
        text34: 'ライト下高さ',
        text35: '長さ幅',
        text36: '階層',

        text21: 'ホーム',
        text22: '会議空間',
        text23: '客室',
        text24: '飲食',
        text25: '付帯設備',
        text26: '位置及周边び',
        text27: '图集',
        text28: '活動事例',
        text29: 'ホテルプロモーション',

        text37: 'あなたのために見つけました',
        text38: '軒のホテル',
        text39: '箇の会議場所',
        text40: 'データ検証',
        text41: '住所',
        text42: '会場面積',
        text43: '最大収容',
        text44: '会場数',
        text45: '客室数',
        text46: '会場参考価格',
        text47: '客室参考価格',
        text48: '間',
        text49: '人',
        share: 'シェア',
    },
    conferenceSpace_active: {},
    conferenceSpace_canteen: {
        text1: '飲食',
        text2: '合計',
        text3: 'レストラン',
        text4: '個室',
        text5: '最大飲食面積',
        text6: '収容飲食人数',
        text7: '面積',
        text8: '位置',
        text9: '层高',
        text10: 'ライト下高さ',
        text11: '独立個室',
        text12: '箇',
        text13: '総席位数',
        text14: '席',
        text15: '一人当たり消費',
        text16: '営業時間',
    },
    conferenceSpace_facility: {
        text1: '付帯設備',
        text2: 'ホテルサービス設備'
    },
    conferenceSpace_home: {
        text1: '本ホテルデータはホテルと会之星プラットフォームによって共同検証済み',
        text2: '外観',
        text3: 'ロビー',
        text4: '付帯',
        text5: '会議空間',
        text6: '客室',
        text7: 'レストラン',
        text8: 'ホテル概要及特色',
        text9: '会議空間',
        text10: '間',
        text11: '客室',
        text12: '最大会場',
        text13: 'レストラン',
        text14: '最大収容',
        text15: '駐車スペース',
        text16: 'ツインベッド数',
        text17: 'ダブルベッド数',
        text18: '客室参考価格',
        text19: 'レストラン料理',
        text20: '個室数',
        text21: 'ホテルブランド',
        text22: '開業時間',
        text23: '最近裝修',
        text24: '会議空間',
        text25: '会議空間',
        text26: '合計',
        text27: '箇',
        text28: '最大会場',
        text29: '最大収容人数',
        text30: '人',
        text31: '会議室',
        text32: '面積',
        text33: '年',
        text34: '最大収容',
        text35: 'レイアウト及収容人数',
        text36: '参考価格（季節等因素により変動）',
        text37: '客室',
        text38: '間',
        text39: '数',
        text40: 'インターネット方式',
        text41: '窓の有無',
        text42: 'インターネット方式',
        text43: '無線インターネット',
        text44: 'はい',
        text45: 'いいえ',
        text46: '飲食',
        text47: '個室',
        text48: '最大飲食面積',
        text49: '収容飲食人数',
        text50: '個室数',
        text51: '席数',
        text52: '一人当たり消費（季節等因素により変動）',
        text53: '長さ幅',
        text54: '层高',
        text55: 'ライト下高さ',
        text56: '元',
    },
    conferenceSpace_imagePage: {},
    conferenceSpace_location: {
        text1: '位置及周边び',
        text2: '住所をコピー',
        text3: 'コピー成功',
        text4: 'コピー失敗',
    },
    conferenceSpace_promotion: {},
    conferenceSpace_room: {
        text1: '客室',
        text2: '間',
        text3: 'から',
    },
    conferenceSpace_venue: {
        text1: '会議空間',
        text2: '合計',
        text3: '箇',
        text4: '最大会場',
        text5: '人',
        text6: '会議室',
        text7: '面積',
        text8: 'レイアウト及収容人数',
        text9: '参考価格（季節等因素により変動）',
        text10: '長さ幅',
        text11: '层高',
        text12: 'ライト下高さ',
        text13: '最大収容人数',
        text14: '最大収容',
    },
    conferenceSpace_vanueDetail: {
        text1: '面積',
        text2: '長さ幅',
        text3: '层高',
        text4: 'ライト下高さ',
        text5: '階層',
        text6: '摆台及容量',
        text7: 'シアタースタイル',
        text8: 'スクールスタイル',
        text9: '中式宴会',
        text10: '西式宴会',
        text11: 'カクテルスタイル',
        text12: 'フィッシュボーン/アイランド',
        text13: 'U字型/回字形',
        text14: '位置及周边び',
        text15: '住所をコピー',
        text16: '董事会'
    },
    customer: {
        text1: '公司部門',
    },
    encyclopedia: {
        text1: '公開日',
    },
    loginInterface_loginInterface: {
        text1: 'ホテル及会議場入居ガイド',
        text2: '入居ガイド動画',
        text3: '会之星販売アシスタント：ホテル販売受注及報價ガイド',
        text4: '会之星に入居',
        text5: 'もっと受注',
        text6: '会議オーダー',
        text7: '効率的オンライン推單',
        text8: 'プラットフォーム人工審査、推單より正確',
        text9: '便捷APP受注',
        text10: 'APP小程序极速受注',
        text11: '智能訂單匹配',
        text12: 'ニーズに応じて、快速匹配会議場',
        text13: '専職バトラーサービス',
        text14: '専職客服バトラー、1対1貼心サービス',
    },
    loginInterface_enterForm: {
        text01: '認証コードを取得',
        text00: '再送信',
        text000: '秒',
        text0: '選択してください',
        text1: '認証コード',
        text2: '入力してください',
        text3: '所在ホテル',
        text4: 'あなたの職位',
        text5: 'メールアドレス',
        text6: '名刺情報',
        text7: '営業許可証',
        text8: '姓名',
        text9: '性別',
        text10: '男性',
        text11: '女性',
        text12: '不明',
        text13: 'ユーザー名',
        text14: '携帯番号',
        text15: 'パスワード設定',
        text16: 'パスワード確認',
        text17: '入居申請成功',
        text18: 'クリックしてログインへ',
        text19: '戻る',
        text20: '前へ',
        text200: '次へ',
        text21: '申請提出',
        text22: '会之星ホテル登録ヒント',
        text23: '一、登録须知',
        text24: '会之星販売アシスタントを登録する前に、あなたの所在ホテル/会場が会之星と合作契約を結び、ホテル/会場基本情報の录入が完了していることを確認してください。未签约合作の場合、登録情報は審査を通りません',
        text25: '二、登録フロー',
        text26: '1.個人及職業实名情報を提出',
        text27: '2.会之星が情報を審査しホテルと確認',
        text28: '3.アカウント開設',
        text29: 'ホテル/会場加盟はお電話ください：',
        text30: 'ホテル情報',
        text31: '登録情報',
        text32: '申請提出',
        text33: '居民身分証',
        text34: '港澳居民来往内地通行証',
        text35: '台湾居民来往大陸通行証',
        text36: '外国人永久居留証',
        text37: '姓名を入力してください',
        text38: '性別を選択してください',
        text39: '証明書類タイプを選択してください',
        text40: '証明書類正面をアップロードしてください',
        text41: '証明書類反面をアップロードしてください',
        text42: '所在ホテルを入力してください',
        text43: '職位を入力してください',
        text44: '名刺をアップロードしてください',
        text45: '営業許可証をアップロードしてください',
        text46: '英文または数字を入力してください',
        text47: 'パスワードを入力してください',
        text48: 'パスワードを再度確認してください',
        text49: '正しい携帯電話番号を入力してください',
        text50: '正しいメールアドレスを入力してください',
        text05: 'メール',
        text51: '確認パスワードとパスワードが一致しません。修正后再提出してください！',
        text52: '提出成功！',
        text53: '送信成功！',
        text54: '送信失敗、後ほど再試行してください！',
        text55: '国',
        text56: '選択してください',
        text57: '国際区域',
        text58: '境内',
        text59: '境外',
        text60: '入居タイプ',
        text61: 'サービスプロバイダー入居',
    },
    matchingService: {
        text1: '会議、展覧会または祝賀活動を举办する際、会場設営は非常に重要な环节です。私たちは専門的な会場設営サービスを提供しており、お電話一本で、私たちのチームが現場に赴き、詳細な会場測定を行い、専門的なアドバイスを提供します。豊富な設計と施工経験を持ち、客戶のニーズに応じて設計から設置までのワンストップサービスを提供し、各环节が完璧に連携することを保証します。私たちのサービスは客戶の時間とコストを節約するだけでなく、活動の顺利进行を保証し、最良の効果を呈現します。',
        text2: '会小通公司拥有多年的公関会議和活动服务经验，能够在完全满足设备要求的前提下，以低成本配置实现高效利用。在完美实现视觉效果的同时，为客户有效节省设备租赁和使用成本。在公関活动和商务会议中，音响设备尤为重要，因为它是现场所有声音来源的保障。会议服务专家会根据场地的不同和会议性质的差异，提供定制的音响解决方案。音响解决方案的关键因素包括活动场地的面积、场地高度、会议形式以及会议内容等方面。',
        text3: 'PAR灯',
        text4: '一般用于面光，可安装不同颜色的色片，配合现场演出等环节。亦称筒灯主要特性是射出较固定的光束，光束角度宽窄多种，光斑大小不能调整。',
        text5: '频闪灯',
        text6: '一般用于面光，可安装不同颜色的色片，配合现场演出等环节。',
        text7: '散光灯',
        text8: '多用于景物的大面积照明和天幕的照明，室外较多使用。',
        text9: '六眼灯',
        text10: '常用于舞台的大面积照明和观众区域的照明使用。',
        text11: '回光灯',
        text12: '舞台的大面积照明，常用语面光、测光及逆光等。',
        text13: '灯光控制台',
        text14: '可编程、储存信息，调控灯光变化，随同活动现场音乐即席配合演出。',
        text15: '扫描灯',
        text16: '品种、型号多样，花样丰富，多用于大型演出活动或演唱会。',
        text17: '激光灯',
        text18: '绚丽多彩的成像效果，可编程设计成像图案，多用于大型演出和大型。',
        text19: '成像灯',
        text20: '可多种形状成像，明亮度高。或称成型灯、椭球聚光灯。主要特性是如幻灯似的能将光斑切割成方、菱形、三角形等各种形状，或投射出所需各种图案花纹，功率也有1KW、2KW等可选择配置。',
        text21: '追光灯',
        text22: '活动用与人物的特写与跟踪使用，效果极佳。 主要在舞台全场黑暗的情况下用光柱突出演员或其他特殊效果，或对演员进行补光。追光灯可以变换各种不同的颜色，还有的追光灯可以打出不同的图案。特点是要人操纵，跟随演员移动。追光灯应用甚广，比如舞台剧、婚庆典礼、会场开幕式、闭幕式等场合都是常见的灯光效果用具。',
        text23: '电脑灯',
        text24: '多种花色、频闪等特殊效果。可安装LOGO片，适用于演出活动和各种效果配合。是一种高科技的专业级舞台灯光，由于其光源的特殊性、结构的复杂性和效果的多样性，舞台电脑灯大量运用在大型体育场馆、户外演出、剧院剧场及电视台演播室，成为舞台灯光应用的主流配置。',
        text25: '作为展示视觉效果和宣讲内容的核心设备，投影仪已成为公关会议和活动的标配。会小通的供应商具备多年的公关会议服务经验，了解不同类型和规模的会议对投影流明数的需求。他们根据各种品牌投影仪的色彩还原能力和特点，为客户量身推荐合适的设备，这正是会小通服务专家独到之处。LED显示屏适用于大型体育场馆、电视直播、展览场馆、年会、产品发布会和文艺演出等场所，可显示变化的数字、文字、图形和图像。它不仅适用于室内，还能在室外环境中使用，具有高亮度、低工作电压、低功耗、小型化、长寿命、耐冲击和性能稳定等优势。在向客户推荐大型LED屏幕时，会小通会根据会议类型和现场座位安排，推荐合适的点数和像素数，以满足活动需求并尽量为客户节省成本。',
        text26: '流明',
        text27: '人数',
        text28: '适用场合',
        text29: '较暗的环境，搭配100寸幕布最佳',
        text30: '人',
        text31: '较暗的会场，搭配100寸/120寸幕布效果最佳',
        text32: '较暗的会场，搭配150以下寸幕布效果最佳',
        text33: '低自然光的环境，搭配150寸幕布效果最佳',
        text34: '低自然光的环境，搭配150寸以上幕布效果最佳',
        text35: '低自然光的环境，根据要求可搭配定做大型号幕布',
        text36: '或大型演出',
        text37: '专业的摄影摄像服务是记录和传播精彩瞬间的关键。我们提供高质量的摄影摄像服务，拥有一支经验丰富、技术精湛的团队，能够捕捉活动中的每一个重要时刻。无论是高清摄像、照片拍摄还是后期制作，我们都能为您提供一站式服务，确保最终呈现的效果完美无缺。我们使用先进的摄影摄像设备，并根据活动的具体需求和场地条件，制定个性化的拍摄方案，为客户提供最佳的视觉记录和宣传素材。',
        text38: '专业DV数码摄像机',
        text39: '摇臂摄像机',
        text40: '索尼、松下等品牌，光学变焦12倍、16倍',
        text41: '美国占美全自动重型摇臂可调节距离为8米，10米，12米',
        text42: '索尼、松下等品牌，光学变焦12倍、16倍',
        text43: '美国占美全自动重型摇臂可调节距离为8米，10米，12米',
        text44: '直播服务已经成为会议、论坛、展览等各类线下活动的重要一环，现场直播可以放大线下活动的宣传效果。我们拥有经验丰富的服务团队，为您提供专业、高性价比的现场直播技术服务和解决方案，包括摄影摄像、导播、推流等一站式直播服务。我们使用先进的直播技术，根据客户的具体需求，制定个性化的直播方案和服务，并提供丰富的功能。我们提供的直播服务包括：视频包装直播、多平台推流、多机位视频直播、自定义布局、实时导播、直播字幕、直播文案、直播回放等，多平台推流支持直播到视频号，小红书、抖音等公域平台，同时也可以为客户提供私域直播解决方案。',
        text45: '专业的车辆服务是确保嘉宾和工作人员准时、安全抵达的重要保障。我们提供一流的车辆服务，包括豪华轿车、商务车、大巴等多种车型，满足不同规模和层次的需求。我们的司机团队经验丰富，熟悉城市道路和活动场地，能够提供准时、安全、舒适的接送服务。无论是接送贵宾、机场接送，还是活动期间的交通调度，我们都能为客户提供定制化的解决方案，确保活动顺利进行，提升客户和嘉宾的整体体验。',
        text46: '品牌',
        text47: '车型',
        text48: '载客',
        text49: '车辆配置',
        text50: '设计策划是确保活动成功的核心环节。我们提供全面的设计策划服务，从创意构想到细节执行，为客户打造独特且具有吸引力的活动方案。我们的团队由经验丰富的设计师和策划专家组成，能够根据客户的需求和活动目标，制定个性化的设计方案，包括视觉风格、布置布局、主题创意等。我们注重细节，确保每个设计元素都与活动主题完美契合，同时考虑到功能性和观众体验。我们的目标是通过专业的设计策划，提升活动的整体效果，为客户创造令人难忘的体验。',
        text51: '翻译服务是确保跨语言交流顺畅的重要保障。我们提供专业的翻译服务，包括同声传译、交替传译以及文件翻译，能够满足各种语言需求。我们的翻译团队由经验丰富的语言专家组成，具备丰富的行业知识和翻译经验，能够在各种活动场合中提供准确、高效的翻译支持。无论是国际会议、商务洽谈还是多语言展示，我们都能确保信息传达无误，帮助各方顺利沟通，提升活动的整体效果。',
        text52: '演员和节目是吸引观众和提升活动氛围的关键元素。我们提供高水平的演员节目服务，涵盖各种表演形式，包括舞蹈、音乐、戏剧、脱口秀等。我们的演员团队由专业艺术家组成，他们具有丰富的演出经验和卓越的表演技巧，能够根据活动主题和观众需求，量身定制精彩纷呈的节目。我们确保每一场演出都能完美呈现，带给观众独特而难忘的体验，为您的活动增添亮点和活力。',
        text53: '礼仪服务是提升活动专业形象和确保流程顺畅的关键。我们提供全面的礼仪服务，包括迎宾接待、引导服务、礼仪人员安排等，致力于为您的活动营造得体且高效的氛围。我们的礼仪团队由训练有素的专业人员组成，能够为嘉宾提供热情周到的服务，确保每一位宾客都能感受到尊重和关怀。无论是活动的签到、引导、还是现场协调，我们都能根据活动的具体需求，提供量身定制的礼仪服务，提升活动的整体品质和观众体验。',
        text54: '在举办年会或庆典活动时，精心的礼仪服务能够提升活动的庄重氛围和专业形象。我们的礼仪团队由训练有素的专业人员组成，能够以热情、周到的服务迎接每一位嘉宾，并协助处理各种突发情况。无论是大型年会、公司庆典还是私人聚会，我们都能根据活动规模和主题，提供量身定制的礼仪方案，帮助您打造一个难忘且高效的庆祝盛典。',
        text55: '在举办论坛活动时，优质的礼仪服务是确保活动顺利进行和提升专业形象的关键。无论是开幕式、圆桌讨论还是闭幕致辞，我们都能根据活动的需求和规模，提供量身定制的礼仪服务，确保论坛顺利进行并提升整体体验。',
        text56: '在举办品牌推广和发布会时，优质的礼仪服务能够有效提升活动的专业度和品牌形象。无论是品牌发布、产品展示还是媒体见面会，我们都能根据活动的具体需求和规模，提供量身定制的礼仪方案，帮助您成功塑造品牌形象并提升活动的整体效果。',
        text57: '精美的鲜花装饰是提升场地氛围和增添视觉美感的关键元素。我们提供专业的鲜花装饰服务，从花艺设计到现场布置，致力于为您的活动打造独特而优雅的环境。我们的花艺团队由经验丰富的设计师组成，他们能够根据活动主题、场地特点和客户需求，创作出令人惊艳的花艺作品。无论是舞台布置、迎宾区域还是桌面装饰，我们都能提供量身定制的方案，确保每一个细节都完美呈现，为您的活动增添色彩和品位。',
        text58: '高质量的印刷材料是展示信息和提升活动形象的关键。我们提供专业的印刷服务，包括会议手册、宣传册、名片、海报、横幅等各类印刷品。我们的团队拥有丰富的设计和印刷经验，使用先进的印刷设备和高质量的材料，确保每一份印刷品都具有卓越的视觉效果和触感。无论是品牌推广资料、活动指南还是宣传海报，我们都能根据客户的需求提供定制化的设计和印刷方案，帮助您以最佳的方式传达信息和提升活动的整体形象。',
        text59: '定制礼品是表达感谢和提升活动纪念价值的绝佳方式。我们提供专业的礼品定制服务，包括企业礼品、纪念品、奖品等各种类型的礼品。我们的团队具备丰富的设计经验和供应链资源，能够根据客户需求和活动主题，提供独特而具有纪念意义的定制礼品。无论是高端礼品盒、定制文具、品牌纪念品还是创意小物件，我们都能为您提供量身定制的解决方案，确保每一份礼品都能传达心意，提升品牌形象，并为您的活动增添亮点和意义。',
        text60: '根据客户的历史数据，会小通为客户提供更多的背景信息，以提高成单率并提升对客户的服务质量。',
        text61: '客户需求请拨打',

        text62: '会場設営',
        text63: '音響照明',
        text64: 'ビデオプロジェクション',
        text65: '撮影カメラ',
        text66: 'ライブ配信サービス',
        text67: '車両サービス',
        text68: '設計企画',
        text69: '翻訳サービス',
        text70: '俳優プログラム',
        text71: '儀礼サービス',
        text72: '装飾',
        text73: '印刷材料',
        text74: 'ギフトカスタマイズ',

        text75: '宇通バス',
        text76: '大型バス',
        text77: '席',
        text78: '根据客户的历史数据，会小通为客户提供更多的背景信息，以提高成单率并提升对客户的服务质量。',
        text79: '中型バス',
        text80: '高背软椅，冷暖空调，高级音响，液晶电视，六碟VCD，大行李仓，ABS。',
        text81: '高背软椅，冷暖空调，高级音响，大行李仓，ABS。',
        text82: '高背软椅，冷暖空调，高级音响。',
    },
    userPage_address: {
        text1: '住所を追加',
        text2: '姓名',
        text3: '携帯番号',
        text4: '地区',
        text5: '詳細住所',
        text6: '姓名を入力してください',
        text7: '携帯番号を入力してください',
        text8: '地区を選択してください',
        text9: '詳細住所を入力してください',
        text10: 'キャンセル',
        text11: '確定',
        text12: '操作',
        text13: '編集',
        text14: '削除',
        deleteSuccess: '削除成功',
        updateSuccess: '編集成功',
        addSucccess: '追加成功',
    },
    userPage_detail: {
        text1: '注文状態',
        text2: '会議专员',
        text3: '注文番号',
        text4: '注文時間',
        text5: '報價単リスト',
        text6: 'ホテル名',
        text7: '会議室',
        text8: '会場価格',
        text99: '食事',
        text9: '食事価格',
        text1010: '宿泊部屋',
        text10: '宿泊価格',
        text11: 'ホテル備考',
        text12: '操作',
        text13: 'ニーズ情報',
        text14: '活動都市',
        text15: '举办時間',
        text16: '活動人数',
        text17: '活動予算',
        text18: '活動タイプ',
        text19: '活動ニーズ',
        text20: '個人情報',
        text21: '連絡先',
        text22: '携帯電話番号',
        text23: '会社名',

        text24: '会場全天価格',
        text25: '会場半天価格',
        text26: 'Led幅',
        text27: 'Led高さ',
        text28: '会場設営費用',
        text29: '会場設営説明',
        text30: '食事タイプ',
        text31: '食事価格',
        text32: '採用済',
        text33: '未採用',
        text34: '部屋タイプ',
        text35: '部屋価格',
        text36: '採用',
    },
    userPage_home: {
        text0: '現在ポイント',
        text1: '資料修改',
        text2: 'ポイントモール',
        text3: 'ポイント注文',
        text4: '顧客住所',
        text5: '注文なし',
        text6: '注文番号',
        text7: '公開日',
        text8: '予算',
        text9: '人数',
        text10: '活動都市',
        text11: '活動タイプ',
        text12: '活動日付',
        text13: '活動ニーズ',
        text14: '会場方案取得待ち（檔期報價含む）',
        text15: '顧問がホテル報價を招待、25分程度で3-6個の会場方案を厳選',
        text16: '報價済リスト及詳細情報を表示',

        text17: '私の情報',
        text18: '個人情報',
        text19: '住所管理',
        text20: '私の注文',
        text21: 'ホテル注文',
        text22: '付帯設備注文',
        text23: 'ポイントモール',
        text24: 'ポイント交換',
        text25: 'ポイント注文',
        text26: 'ポイントルール',
        text27: 'ポイント明細',
        text28: 'アフターサービス',
        text29: '請求書発行',
        text30: 'ログアウトを確定しますか？',
        text31: 'ログアウト',
    },
    userPage_infoPage: {
        text1: 'あなたの情報',
        text2: '姓名',
        text3: '姓名を入力してください',
        text4: '性別',
        text5: '性別を選択してください',
        text6: '男性',
        text7: '女性',
        text8: '不明',
        text9: '誕生日',
        text10: '誕生日を選択してください',
        text11: '電子メール',
        text12: '電子メールを入力してください',
        text13: 'QQ番号を入力してください',
        text14: 'WeChat ID',
        text15: 'WeChat IDを入力してください',
        text16: '企業名',
        text17: '企業名を入力してください',
        text18: '所属部門',
        text19: '所属部門を選択してください',
        text20: 'あなたの職位',
        text21: '職位を選択してください',
        text22: '提出'
    },
    userPage_login: {
        text1: '会之星',
        text2: '顧客管理システム',
        text3: 'ワンストップ会議サービスプラットフォーム',
        text4: 'こんにちは！',
        text5: '会之星顧客管理システムへようこそ',
        text6: '携帯番号を入力してください',
        text7: '認証コードを入力してください',
        text8: 'ログイン',
        text9: '認証コードを送信',
        text10: 'まず携帯番号を入力して認証コードを取得してください',
        text11: '再送信',
    },
    userPage_shop: {
        text1: 'ポイント価格',
        text2: 'すべて',
    },
    userPage_shopDetail: {
        text1: 'ポイント価格',
        text2: '残り数量',
        text3: '注文数量',
        text4: '説明テキスト',
        text5: '住所を選択',
        text6: '選択してください',
        text7: '認証コード',
        text8: '購入',
        text9: '認証コードを送信',
        text10: '注文成功',

        text11: '住所を選択してください',
        text12: '認証コードを入力してください',
        text13: '注文を確定しますか',
        text14: 'キャンセルボタンがクリックされました',
        text15: '確定をクリックすると、あなたの携帯番号（{phoneNumber}）に認証コードを送信します。送信しますか？',
        text16: '現在ポイント不足'
    },
    userPage_waresOrder: {
        text1: '商品名',
        text2: 'タイプ',
        text3: '注文番号',
        text4: '携帯番号',
        text5: '住所',
    },
    Index_page: {
        text1: '会議ニーズを公開',
        text2: '会議顧問1対1で会場探し、檔期確認、最低価格照会',
        text03: '国際注文ですか？',
        text3: 'どこで活動を行いますか？',
        text4: '検索试试：ガイド',
        text5: 'どのような活動を行いますか？',
        text6: '活動日付',
        text7: '日付を選択',
        text8: '活動期間',
        text9: '参加人数',
        text10: '概算予算',
        text11: 'あなたのプロジェクトニーズ',
        text12: '広告企画、舞台美術設営などの他の付帯サービスが必要',
        text13: '無料で会場をマッチング',
        text14: '1分',
        text15: '会議ニーズを公開',
        text16: '10分',
        text17: '会議顧問が電話',
        text18: '30分',
        text19: '会議方案を取得',
        text20: '戻ってニーズを修改',
        text21: 'あなたの活動を確認してください',
        text22: 'あなたは',
        text23: 'で',
        text24: '開始時間は',
        text25: '期間',
        text26: '人数は',
        text27: '予算は',
        text28: '含む',
        text29: 'などの活動ニーズ',
        text30: '会場方案及報價を受け取るために、あなたの携帯番号を入力してください',
        text31: '認証コードを取得',
        text32: '無料で会場報價、檔期を取得',
        text33: '会議ニーズを提出することは',
        text34: '《会之星ユーザー協議》',
        text35: '《プライバシー保護政策》',
        text36: '会之星を使用する初衷',
        text37: '効率的に理想的な会場をマッチング',
        text38: 'グローバルホテルと会議特色会場に直結、一键で会議情報を公開、快速に報價を取得',
        text39: 'システム智能検索询价、会場性价比更高',
        text40: 'プラットフォーム会議会場智能比价、割引力度30%+',
        text41: '会議設備付帯サービスをサポート',
        text42: 'プラットフォームで舞台美術、企画、設営、物料、車両、购票などをワンストップで解決',
        text43: 'ユーザーは無料でプラットフォームを使用',
        text44: 'オンラインオフライン会議顧問一对一サービス',
        text45: 'オフライン会議サービスより専門的',
        text46: 'プラットフォームオンラインで会場をマッチング、オフライン专业服务より贴心的',
        text47: '全国で会議を行う良い場所',
        text48: '厳選会議会場',
        text49: '会場面積',
        text50: '人気会議ホテル',
        text51: '最大会場面積',
        text52: '都市周辺で会議を行う良い場所',
    },
    activityDetail: {
        text1: '宿泊説明', // 活动说明标题
        text2: '展開', // 展开按钮文案
        text3: '折りたたむ', // 收起按钮文案
        text4: '会之星が技術サポートを提供', // 底部技术支持文字
        text5: 'イベント情報が見つかりません。正しい入口からご入場ください', // 缺少活动ID提示
        text6: '読み込み中...', // 加载中文案
        text7: 'クリックして再試行', // 重试按钮文案
        text8: 'イベント情報の読み込みに失敗しました', // 加载失败文案
    }
}